import { createLucideIcon } from 'lucide-react';
export const UserIcon = createLucideIcon('user-icon', [
  [
    'path',
    {
      d: 'M7 19C7 19 7 13 12 13C17 13 17 19 17 19',
      key: 'z9nllz',
    },
  ],
  [
    'path',
    {
      d: 'M8 9C8 6.78906 9.78906 5 12 5C14.2109 5 16 6.78906 16 9C16 11.2109 14.2109 13 12 13C9.78906 13 8 11.2109 8 9Z',
      key: '1419yw',
    },
  ],
]);
